import { createQueryFactory } from "../query-factory";

export const { useApiHook: useGetCurrentEmployee } = createQueryFactory(
	"getCurrentEmployee",
);
